import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class SampleApi {

    static get() {
        return HTTP.get(config.sampleApi.sample)
            .then(response => response.data)
    }

    static add(shoppingCartItem) {
        return HTTP.post(config.sampleApi.sample, shoppingCartItem)
            .then(response => response.data)
    }

    static update(shoppingCartItem) {
        return HTTP.put(config.sampleApi.sample, shoppingCartItem)
            .then(response => response.data)
    }

    static remove(itemId) {
        return HTTP.delete(`${config.sampleApi.sample}/item/${itemId}`)
            .then(response => response.data)
    }

    static checkout(sampleOrder) {
        return HTTP.post(`${config.sampleApi.sample}/checkout/`, sampleOrder)
            .then(response => response.data)
    }

    static checkoutAdmin(sampleOrder) {
        return HTTP.post(`${config.sampleApi.sampleAdmin}/checkout`, sampleOrder)
            .then(response => response.data)
    }
}